/**
 * #1316 — one attempt of the chat send, bound to the session it was sent in.
 *
 * The send retries (a gateway failure, a busy session draining — `fetchWithGatewayRetry` and the 409 loop), and each
 * attempt rebuilds its headers. So once the session that sent it (`sentSession`, read when the send started) has
 * ended, no attempt goes out — it would be sent as the NEXT session — and an answer that arrives after the end tells no
 * one: the send fails with `sessionEnded()` (the "may not have been sent" message, P8). A live session's answers,
 * refusals included, pass through untouched for the caller to retry or report.
 */
import { isSessionEndedError } from '@papan/api-client'

export function sessionBoundAttempt(
  send: () => Promise<Response>,
  sentSession: AbortSignal | undefined,
  sessionEnded: () => Error,
): () => Promise<Response> {
  return async () => {
    if (sentSession?.aborted) throw sessionEnded()
    let res: Response
    try {
      res = await send()
    } catch (err) {
      // a dropped answer (`sessionFetch`): the session ended while the request was out
      if (isSessionEndedError(err)) throw sessionEnded()
      throw err
    }
    // a refusal answered after the session ended is not retried, nor reported as a refusal
    if (!res.ok && sentSession?.aborted) {
      void res.body?.cancel().catch(() => {})
      throw sessionEnded()
    }
    return res
  }
}
